import { useCallback, useMemo, useState } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import type { UseCustomTable, UseCustomTableValues } from './types'
import { getToggleTableButtonLabel } from './utils'

export const useCustomTable = ({ title }: UseCustomTable): UseCustomTableValues => {
  const [open, setOpen] = useState(false)
  const { t } = useFavurTranslation()
  const toggleTableButtonAction = useCallback(() => setOpen((previousValue) => !previousValue), [])
  const toggleTableButtonLabel = useMemo(() => getToggleTableButtonLabel({ open, t, title }), [open, t, title])

  return {
    open,
    toggleTableButtonAction,
    toggleTableButtonLabel,
  }
}
